import React from 'react';
import { ScanIcon } from 'lucide-react';
export const Header = () => {
  return <header className="bg-[#e76405] text-white p-3 shadow-md sticky top-0 z-10" data-id="element-14">
      <div className="flex items-center justify-between" data-id="element-15">
        <div className="flex items-center gap-2" data-id="element-16">
          <ScanIcon size={20} data-id="element-17" />
          <h1 className="text-lg font-bold" data-id="element-18">Production Scanner</h1>
        </div>
        <div className="text-xs" data-id="element-19">{new Date().toLocaleDateString()}</div>
      </div>
    </header>;
};